var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useRef } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { MenuStyled, MenuDropdownStyled } from './styledComponents';
export var Menu = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClick = _a.onClick, className = _a.className, onClickOutside = _a.onClickOutside, props = __rest(_a, ["children", "isOpen", "onClick", "className", "onClickOutside"]);
    return (<ClickAwayListener onClickAway={onClickOutside}>
      <MenuStyled data-testid="menu" onClick={onClick} isOpen={isOpen} className={className} onKeyUp={function (e) { return e.preventDefault(); }} {...props}>
        {children} <KeyboardArrowDownIcon className="menu-arrow-icon"/>
      </MenuStyled>
    </ClickAwayListener>);
};
export var MenuDropdown = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.propagateClick, propagateClick = _b === void 0 ? false : _b, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, _d = _a.unmountOnClose, unmountOnClose = _d === void 0 ? false : _d, _e = _a.position, position = _e === void 0 ? 'center' : _e, props = __rest(_a, ["children", "className", "propagateClick", "isOpen", "unmountOnClose", "position"]);
    // This ref prevents the grow animation from running on page load
    var shouldAnimate = useRef(false);
    if (isOpen) {
        shouldAnimate.current = true;
    }
    if (!isOpen && unmountOnClose) {
        return null;
    }
    return (<MenuDropdownStyled data-testid="menu-dropdown" className={className} onClick={function (e) { return (propagateClick ? null : e.stopPropagation()); }} isOpen={isOpen} shouldAnimate={shouldAnimate.current} position={position} {...props}>
      {children}
    </MenuDropdownStyled>);
};
